/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AktionReihenfolgeSetzenMultiRequest { 
    aktion_ids: Array<string>;
    veranstaltung_id: string;
}

